import React from 'react'

import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'

const BenefitCard = ({icon, benefitText}) => {
    const styles = useMultiStyleConfig('BenefitCard')

    return (
        <Box {...styles.card}>
            {icon}
            <Flex {...styles.textContainter}>
                <Text {...styles.strongText}>{benefitText}</Text>
            </Flex>
        </Box>
    )
}

BenefitCard.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
    benefitText: PropTypes.node,
}

export default BenefitCard
